import "./ListLocalSiteName.scss"
import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import DatatableSiteLocalName from "../../../components/datatableLocalSiteName/DatatableSiteLocalName";

const ListLocalSiteName = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DatatableSiteLocalName columns={columns}/>
      </div>
    </div>
  )
}

export default ListLocalSiteName